export function smoothScrollTo(targetY: number, duration = 250) {
    const startY = window.scrollY;
    const diff = targetY - startY;
    if (diff === 0) return;

    const startTime = performance.now();
    const step = (now: number) => {
        const t = Math.min((now - startTime) / duration, 1);
        const ease = t * (2 - t); // easeOutQuad
        window.scrollTo(0, startY + diff * ease);
        if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
}
